module.exports = __webpack_public_path__ + "img/V14.49bdd095.png";